import React from "react";
import PricingTable from "./PricingTable";
import BoldCell from "./BoldCell";
import Tick from "../Tick";
import { css } from "@emotion/react";
import { pricingInfo } from "../../data/pricing-page-data";
import { pxToRem } from "@upsun/react-component-library/src/styles/css-utils";
type ProjectsTableProps = {
  currency: string
};

const ProjectsTable: React.FC<ProjectsTableProps> = ({ currency, ...props }) => {
  const smallMargin = css`
    p {
      margin: 0;
    }
  `;

  const smallerText = css`
    font-size: ${pxToRem(14)};
  `

  return (
    <PricingTable>
      <tbody>
        <tr>
          <BoldCell>Project fee</BoldCell>
          <td>{pricingInfo.projectFee[currency]}/project/month</td>
        </tr>
        <tr>
          <BoldCell>Production domains per project</BoldCell>
          <td>100</td>
        </tr>
        <tr>
          <BoldCell>Let's Encrypt TLS certificates</BoldCell>
          <td>100</td>
        </tr>
        <tr>
          <BoldCell>Custom client certificates</BoldCell>
          <td>
            <Tick />
          </td>
        </tr>
        <tr>
          <BoldCell css={smallMargin}>
            <p><strong>Advanced uptime SLA</strong></p>
            <p css={smallerText}>Requires advanced support or higher. Minimum subscription term is twelve (12) months.</p>
          </BoldCell>
          <td css={smallMargin}>
            <p><strong>99.9% uptime SLA</strong></p>
            <p>+20% project value</p>
          </td>
        </tr>
        <tr>
          <BoldCell css={smallMargin}>
            <p><strong>Premium uptime SLA</strong></p>
            <p css={smallerText}>Requires advanced support or higher. Minimum subscription term is twelve (12) months.</p>
          </BoldCell>
          <td css={smallMargin}>
            <p><strong>99.99% uptime SLA</strong></p>
            <p>+45% project value</p>
          </td>
        </tr>
      </tbody>
    </PricingTable>
  );
};

export default ProjectsTable;
